export const HOME = {
  emergentLink: "home-emergent-link",
};

export const BRAND = {
  logo: "brand-logo",
  splash: "splash-screen",
  founderBadge: "founder-badge",
};

export const NARRATOR = {
  controls: "narrator-controls",
  voiceFemale: "narrator-voice-female",
  voiceMale: "narrator-voice-male",
  muteToggle: "narrator-mute-toggle",
  playToggle: (id) => `narrator-play-${id}`,
};

export const AUTH = {
  landingHero: "auth-landing-hero",
  welcomeScreen: "auth-welcome-screen",
  welcomeBeginBtn: "auth-welcome-begin-btn",
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  submitBtn: "auth-submit-btn",
  toggleModeBtn: "auth-toggle-mode-btn",
  googleBtn: "auth-google-btn",
  errorMsg: "auth-error-msg",
};

export const NAV = {
  tabOracle: "nav-tab-oracle",
  tabDeck: "nav-tab-deck",
  tabHandDrawn: "nav-tab-handdrawn",
  tabJournal: "nav-tab-journal",
  tabProfile: "nav-tab-profile",
  tabShop: "nav-tab-shop",
  logoutBtn: "nav-logout-btn",
  logoutBtnHeader: "nav-logout-btn-header",
};

export const SHOP = {
  page: "shop-page",
  tierCard: (id) => `shop-tier-${id}`,
  tierOrderBtn: (id) => `shop-tier-order-${id}`,
  checkoutModal: "shop-checkout-modal",
  checkoutName: "shop-checkout-name",
  checkoutAddress: "shop-checkout-address",
  checkoutCity: "shop-checkout-city",
  checkoutPostal: "shop-checkout-postal",
  checkoutCountry: "shop-checkout-country",
  checkoutSubmit: "shop-checkout-submit",
  checkoutCancel: "shop-checkout-cancel",
  orderSuccess: "shop-order-success",
  reserveSheet: "shop-reserve-sheet",
  reserveEmail: "shop-reserve-email",
  reserveSubmit: "shop-reserve-submit",
  reserveCancel: "shop-reserve-cancel",
  reserveSuccess: "shop-reserve-success",
  reserveRemaining: "shop-reserve-remaining",
};

export const SOULMARK = {
  card: "soul-mark-card",
  generateBtn: "soul-mark-generate-btn",
  image: "soul-mark-image",
  saveBtn: "soul-mark-save-btn",
  shareBtn: "soul-mark-share-btn",
};

export const INTAKE = {
  step: "intake-step",
  birthNameInput: "intake-birthname-input",
  birthDateInput: "intake-birthdate-input",
  birthTimeInput: "intake-birthtime-input",
  birthTimeUnknown: "intake-birthtime-unknown",
  birthLocationInput: "intake-birthlocation-input",
  soulNameInput: "intake-soulname-input",
  reflectionInput: (i) => `intake-reflection-${i}`,
  nextDestination: "intake-next-destination",
  reassurance: "intake-reassurance",
  nextBtn: "intake-next-btn",
  backBtn: "intake-back-btn",
  submitBtn: "intake-submit-btn",
};

export const CEREMONY = {
  welcomeContainer: "ceremony-welcome",
  welcomeContinueBtn: "ceremony-welcome-continue",
  characterContainer: "ceremony-character",
  characterContinueBtn: "ceremony-character-continue",
  deckContainer: "ceremony-deck",
  deckContinueBtn: "ceremony-deck-continue",
  deckCard: (i) => `ceremony-deck-card-${i}`,
};

export const ORACLE = {
  home: "oracle-home",
  cardOfDay: "oracle-card-of-day",
  cardTitle: "oracle-card-title",
  moonPhase: "oracle-moon-phase",
  spreadTile: (id) => `oracle-spread-${id}`,
  regenerateBtn: "oracle-regenerate-btn",
  saveToJournalBtn: "oracle-save-journal-btn",
};

export const JOURNAL = {
  page: "journal-page",
  entry: (id) => `journal-entry-${id}`,
  bookmarkBtn: (id) => `journal-bookmark-${id}`,
  deleteBtn: (id) => `journal-delete-${id}`,
  filterAll: "journal-filter-all",
  filterBookmarked: "journal-filter-bookmarked",
};

export const PROFILE = {
  page: "profile-page",
  soulName: "profile-soul-name",
  editSoulNameBtn: "profile-edit-soul-name",
  saveSoulNameBtn: "profile-save-soul-name",
  soulNameInput: "profile-soul-name-input",
  affirmation: "profile-affirmation",
  numerologyCard: (k) => `profile-numerology-${k}`,
  natalCard: (k) => `profile-natal-${k}`,
  countCard: (k) => `profile-count-${k}`,
};

export const DECKHUB = {
  page: "deck-hub-page",
  segment: (id) => `deck-hub-segment-${id}`,
  editionCard: (id) => `deck-hub-edition-${id}`,
  orderBtn: (id) => `deck-hub-order-${id}`,
  checkoutModal: "deck-hub-checkout-modal",
  checkoutName: "deck-hub-checkout-name",
  checkoutAddress: "deck-hub-checkout-address",
  checkoutCity: "deck-hub-checkout-city",
  checkoutPostal: "deck-hub-checkout-postal",
  checkoutCountry: "deck-hub-checkout-country",
  checkoutSubmit: "deck-hub-checkout-submit",
  checkoutCancel: "deck-hub-checkout-cancel",
  houseTile: (el) => `deck-hub-house-${el.toLowerCase()}`,
  housePreviewCard: "deck-hub-house-preview-card",
  chooseHouseBtn: "deck-hub-choose-house-btn",
  chosenHouseBadge: "deck-hub-chosen-house-badge",
};

export const HANDDRAWN = {
  page: "handdrawn-page",
  spreadTile: (id) => `handdrawn-spread-${id}`,
  fanCard: (i) => `handdrawn-fan-card-${i}`,
  wheelModal: "handdrawn-wheel-modal",
  sectionTab: (id) => `handdrawn-section-${id}`,
  wheelCard: (title) => `handdrawn-wheel-card-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
  uprightToggle: "handdrawn-upright-toggle",
  reversedToggle: "handdrawn-reversed-toggle",
  confirmCardBtn: "handdrawn-confirm-card",
  cancelWheelBtn: "handdrawn-cancel-wheel",
  readSpreadBtn: "handdrawn-read-spread",
  resetBtn: "handdrawn-reset",
};

export const SPREAD = {
  page: "spread-page",
  questionInput: "spread-question-input",
  drawBtn: "spread-draw-btn",
  position: (i) => `spread-position-${i}`,
  thread: "spread-thread",
  saveBtn: "spread-save-btn",
};
